import { Link } from "react-router-dom";
import { ClipboardCheck, ShieldCheck, ArrowRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const AnalysisPreview = () => {
    const { t } = useLanguage();
    const P = t.previews.analysis;

    return (
        <section
            id="analysis-preview"
            data-testid="analysis-preview-section"
            className="py-24 md:py-28 bg-ella-onyx text-ella-cream relative overflow-hidden"
        >
            <div className="absolute inset-0 opacity-[0.06] pointer-events-none">
                <div className="absolute top-0 left-1/3 w-96 h-96 rounded-full bg-ella-gold blur-3xl" />
            </div>

            <div className="ella-container relative">
                <div className="grid lg:grid-cols-12 gap-12 items-center">
                    <div className="lg:col-span-7">
                        <span className="ella-overline-light" data-testid="analysis-preview-overline">
                            {P.overline}
                        </span>
                        <h2
                            className="ella-headline text-4xl md:text-5xl mt-4 text-ella-cream"
                            data-testid="analysis-preview-title"
                        >
                            {P.title}
                        </h2>
                        <p className="mt-5 text-ella-cream/70 font-light text-base leading-relaxed max-w-lg">
                            {P.lead}
                        </p>

                        <Link
                            to="/analyse"
                            data-testid="analysis-preview-cta"
                            className="inline-flex items-center gap-3 mt-8 px-8 py-4 rounded-full bg-ella-gold text-ella-onyx hover:bg-ella-cream transition-colors text-xs uppercase tracking-[0.24em]"
                        >
                            <ClipboardCheck className="w-4 h-4" strokeWidth={1.5} />
                            {P.cta}
                            <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
                        </Link>
                    </div>

                    <div className="lg:col-span-5">
                        <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-8 space-y-4">
                            {(t.analysis.steps || []).map((s, i) => (
                                <div
                                    key={i}
                                    data-testid={`analysis-preview-step-${i}`}
                                    className="flex items-center gap-4"
                                >
                                    <span className="w-9 h-9 rounded-full bg-ella-gold/10 border border-ella-gold/30 text-ella-gold flex items-center justify-center font-display text-sm">
                                        {i + 1}
                                    </span>
                                    <span className="text-sm text-ella-cream/85 leading-tight">
                                        {s}
                                    </span>
                                </div>
                            ))}

                            <div className="pt-5 mt-2 border-t border-white/10 flex items-start gap-3">
                                <ShieldCheck
                                    className="w-4 h-4 text-ella-gold flex-shrink-0 mt-0.5"
                                    strokeWidth={1.5}
                                />
                                <p className="text-[11px] text-ella-cream/55 leading-relaxed">
                                    {t.analysis.step_labels.privacy}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AnalysisPreview;
